<ng-template #dataSourceMoreTmpl>
  <rt-dropdown-header>
    <rt-icon-button
      prefix
      [iconName]="'arrow-back'"
      size="small"
      variant="plain"
      (click)="mainDropdown.prevTemplate()"
    />
    {{ 'app.views.view_settings.header' | translate }}
  </rt-dropdown-header>
  <ng-template [rtComponentOutlet]="dataSourceMoreSettingsCmp" />
</ng-template>

<rt-dropdown-item [targetFor]="dataSourceMoreTmpl" (click)="viewsAnalytics.settingsMoreOpen()">
  <rt-icon prefix name="more-horiz" />
  {{ 'app.views.view_settings.more' | translate }}
</rt-dropdown-item>
